import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import secureLocalStorage from 'react-secure-storage';
import moment from 'moment';
import { getCheckInStatus } from 'modules/attendence_leave_tracker/api';
import { userHouseConfig } from 'config';

const ReminderClockOut = ({ shiftTime }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState('');
  const userHouse = secureLocalStorage.getItem('house');

  const parseShiftTime = (shiftTime) => {
    const [start, end] = shiftTime.split('-');
    const shiftStartTime = moment(start, 'HH:mm');
    const shiftEndTime = moment(end, 'HH:mm');

    return { shiftStartTime, shiftEndTime };
  };

  useEffect(() => {
    if (!shiftTime) return;

    const { shiftEndTime } = parseShiftTime(shiftTime);
    const fifteenMinutesBefore = shiftEndTime.clone().subtract(15, 'minutes');
    const fiveMinutesBefore = shiftEndTime.clone().subtract(5, 'minutes');
    const flagForHouse = userHouseConfig.includes(userHouse);

    const checkReminders = async () => {
      const currentTime = moment();

      if (
        currentTime.isBetween(fifteenMinutesBefore, shiftEndTime) &&
        !secureLocalStorage.getItem('fifteenMinReminderShown') && flagForHouse
      ) {
        const isChekedIn = await getCheckInStatus();
        if(isChekedIn?.data?.isUserCheckedIn){
          secureLocalStorage.setItem('fifteenMinReminderShown', 'true');
          showModal('Reminder to clock-out!!');
        }
      } else if (
        currentTime.isBetween(fiveMinutesBefore, shiftEndTime) &&
        !secureLocalStorage.getItem('fiveMinReminderShown') && flagForHouse
      ) {
        const isChekedIn = await getCheckInStatus();
        if(isChekedIn?.data?.isUserCheckedIn){
          secureLocalStorage.setItem('fiveMinReminderShown', 'true');
          showModal('Reminder to clock-out!!');
        }
      }
    };

    const intervalId = setInterval(checkReminders, 10000); // Check every minute

    // Initial check in case the interval is missed by user refreshing or arriving late
    checkReminders();

    return () => {
      clearInterval(intervalId);
    };
  }, [shiftTime]);

  const showModal = (msg) => {
    setMessage(msg);
    setIsModalVisible(true);

    setTimeout(() => {
      setIsModalVisible(false);
    }, 60000); // Hide after 1 minute
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.location.href = '/leave-tracker'; // Redirect to clock-out page
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Modal
        title="Reminder"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            Okay
          </Button>,
        ]}
      >
        <p style={{ color: 'red', fontWeight: 'bold' }}>{message}</p>
      </Modal>
    </div>
  );
};

export default ReminderClockOut;
